export default "__VITE_ASSET__BTvAkz5C__"